import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  body: {
    width: '90%',
    margin: '30px auto',
    paddingTop: '90px'
  },
  button: {
    margin: '30px auto 0 auto'
  }
});
